module.exports = __webpack_public_path__ + "static/img/20-0829-detail2.c14d5d9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/20-0829-detail2.jpeg
// module id = Lk61
// module chunks = 0